module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.billingLevel === 0) ? _c('div', {
    staticClass: "card card-inverse card-success text-xs-center"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.billingLevel === 1) ? _c('div', {
    staticClass: "card card-inverse card-warning text-xs-center"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.billingLevel === 2) ? _c('div', {
    staticClass: "card card-inverse card-danger text-xs-center"
  }, [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_vm._v("\n        Facturation du client à jour.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_vm._v("\n        Facturation du client en retard.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('blockquote', {
    staticClass: "card-blockquote"
  }, [_vm._v("\n        Facturation du client en recouvrement.\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591780f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerBillingSummaryWidget.vue
// module id = 694
// module chunks = 1